import { useContext } from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { GalleryModalContext } from "components/pages/property/listing/components/GalleryModal/context";
import { buildingListingTrackingEvents } from "components/store/source/tracking_events";
import { Image, SwiperCarousel } from "components/ui/source";

import ViewAllPhotosButton from "../ViewAllPhotosButton";

import styles from "./BuildingCarousel.module.scss";

const arrowContainerProps = {
  rounded: true,
  type: "property-building-carousel",
};

const nextArrowProps = {
  iconProps: {
    color: "deep-green",
    size: "lg",
  },
  className: styles.arrow,
  containerProps: arrowContainerProps,
};

const prevArrowProps = {
  iconProps: {
    color: "deep-green",
    size: "lg",
  },
  className: styles.arrow,
  containerProps: arrowContainerProps,
};

function BuildingCarousel({ className, listingId, photos }) {
  const { handleOpen } = useContext(GalleryModalContext);

  if (photos == null || photos.length == 0) return null;

  const isSinglePhoto = photos.length == 1;
  const showArrow = photos.length > 2;

  const onPhotoClick = photoPosition => e => {
    e.stopPropagation();

    return handleOpen(
      photos,
      photoPosition,
      buildingListingTrackingEvents.buildingGalleryViewed,
      { listingId, buildingListing: true },
    );
  };

  const photoElements = photos.map((photo, index) => (
    <div
      key={`property-listing-building-photos-${index}`}
      className={styles.slideContainer}
    >
      <button className={styles.photoContainer} onClick={onPhotoClick(index)}>
        <Image
          className="swiper-lazy"
          type="rounded"
          src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
          alt={photo.caption || ""}
          data-src={isSinglePhoto ? photo.largeSrc : photo.mediumSrc}
          lazyLoad={false}
        />
      </button>
    </div>
  ));

  const props = {
    carouselProps: {
      loop: showArrow,
      slidesPerView: 1,
      allowTouchMove: showArrow,
      spaceBetween: 24,
      lazyLoad: true,
      autoHeight: true,
      breakpoints: {
        // Applied when screen width > mobile-lg
        566: {
          slidesPerView: isSinglePhoto ? 1 : 2,
        },
      },
    },
    nextArrowProps: showArrow ? nextArrowProps : null,
    prevArrowProps: showArrow ? prevArrowProps : null,
  };

  return (
    <div className={classnames(styles.container, className)}>
      <SwiperCarousel {...props}>{photoElements}</SwiperCarousel>

      {showArrow && (
        <ViewAllPhotosButton
          className={styles.viewAllPhotos}
          onClick={onPhotoClick(0)}
        />
      )}
    </div>
  );
}

BuildingCarousel.propTypes = {
  className: PropTypes.string,
  listingId: PropTypes.string,
  photos: PropTypes.arrayOf(PropTypes.object),
};

export default BuildingCarousel;
